import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { css } from '@emotion/react';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { setConnectedSmsProviders } from 'pages/OtherIntegrations/Integrations/integrationsStoresSlice';

import { OTHER_INTEGRATIONS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { faRotate } from '@fortawesome/pro-solid-svg-icons';

import * as S from './SMSProviders.styled';

const DeleteSmsProvider = NiceModal.create(({ smsProvider }) => {
	const modal = useModal();
	const axiosPrivate = useAxiosPrivate();
	const connectedSmsProvidersList = useSelector((state) => state?.integrationsStores?.connectedSmsProviders);
	const { showSuccess, showError } = useAlert();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);

	const removeSmsProvider = async () => {
		setIsLoading(true);
		try {
			const response = await axiosPrivate.post(OTHER_INTEGRATIONS.DELETE_SMS_PROVIDER, {
				ID: smsProvider.smsConfigID
			});
			if (response.status === 200) {
				showSuccess();
				dispatch(
					setConnectedSmsProviders(
						connectedSmsProvidersList.filter((item) => item.smsConfigID !== smsProvider.smsConfigID)
					)
				);
				modal.remove();
			} else {
				AppLogger.error(response);
			}
		} catch (error) {
			if (error.response?.data.code === 'error.C017') {
				showError({
					header: 'errorMsg.thisProviderIsConnected',
					message: 'errorMsg.thisProviderIsConnectedMessage'
				});
			} else {
				showError();
			}
			AppLogger.error(error);
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<Modal maxWidth="x-small" fullwidth closeButton className="remove-provider-confirmation">
			<ModalTitle>
				<Typography variant="p1">removeSmsProvider</Typography>
			</ModalTitle>
			<S.DeleteProviderContainer>
				<S.LogoContainer>
					<Image width="6rem" height="6rem" url={smsProvider?.logo} />
					<Icon icon={faRotate} fontSize="3rem" />
					<Image
						width="6rem"
						height="6rem"
						url="https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png"
					/>
				</S.LogoContainer>
				<Typography variant="p2" fontWeight="500" noWrap align="center">
					{t('removeChannelConfirmation', {
						channelName: t(smsProvider?.title)
					})}
				</Typography>
				<Typography variant="p3" color="var(--content-3)" noWrap align="center">
					removeSmsProviderSubtitle
				</Typography>
			</S.DeleteProviderContainer>
			<ModalActions>
				<Button label="cancel" onClick={() => modal.remove()} variant="action" />
				<Button
					label="removeSmsProvider"
					onClick={removeSmsProvider}
					icon={faTrash}
					css={css`
						background-color: var(--red) !important;
						border-color: var(--red) !important;
					`}
					loading={isLoading}
				/>
			</ModalActions>
		</Modal>
	);
});

export default DeleteSmsProvider;
